import { Cell, Grid, Heading, VFlow } from 'bold-ui'
import { CheckboxField } from 'components/form/core'
import { css } from 'emotion'
import { BeneficioDbEnum } from 'graphql/types.generated'
import { MetaPath } from 'util/metaPath'

export interface BeneficiosCheckboxGroupFieldProps {
  name: MetaPath<BeneficioDbEnum[]>
  values?: ReadonlyArray<BeneficioDbEnum>
}

export function CidadaoAldeadoBeneficiosFieldGroup({ name, values }: Readonly<BeneficiosCheckboxGroupFieldProps>) {
  const disabled = values?.includes(BeneficioDbEnum.NAO_RECEBE_BENEFICIO_SOCIAL)

  return (
    <VFlow style={styles.vflow}>
      <Heading level={3} className={styles.heading}>
        Benefícios do governo
      </Heading>
      <Grid wrap>
        <Cell size={3}>
          <CheckboxField name={name} label='Aposentado' value={BeneficioDbEnum.APOSENTADO} disabled={disabled} />
        </Cell>
        <Cell size={3}>
          <CheckboxField name={name} label='Bolsa família' value={BeneficioDbEnum.BOLSA_FAMILIA} disabled={disabled} />
        </Cell>
        <Cell size={3}>
          <CheckboxField
            name={name}
            label='Leite não humano'
            value={BeneficioDbEnum.LEITE_NAO_HUMANO}
            disabled={disabled}
          />
        </Cell>
        <Cell size={3}>
          <CheckboxField
            name={name}
            label='Outros benefícios'
            value={BeneficioDbEnum.OUTROS_BENEFICIOS}
            disabled={disabled}
          />
        </Cell>
        <Cell size={3}>
          <CheckboxField
            name={name}
            label='Benefício de prestação continuada'
            value={BeneficioDbEnum.BENEFICIO_DE_PRESTACAO_CONTINUADA}
            disabled={disabled}
          />
        </Cell>
        <Cell size={3}>
          <CheckboxField
            name={name}
            label='Cesta de alimento'
            value={BeneficioDbEnum.CESTA_DE_ALIMENTO}
            disabled={disabled}
          />
        </Cell>
        <Cell size={3}>
          <CheckboxField
            name={name}
            label='Não recebe benefício social'
            value={BeneficioDbEnum.NAO_RECEBE_BENEFICIO_SOCIAL}
            disabled={values && values.length > 0 && !disabled}
          />
        </Cell>
        <Cell size={3} />
      </Grid>
    </VFlow>
  )
}

const styles = {
  heading: css`
    margin-bottom: 0.05rem;
    margin-left: 0.2rem;
    font-size: 0.8rem;
  `,
  vflow: css`
    padding: 0.8rem;
  `,
}
